export const getClass = (isFocused, valid, submitting, readOnly, active, touched) => {
    if (!isFocused && !valid) {
        return 'invalid';
    }

    if (submitting || readOnly) {
        return 'disabled';
    }

    if (active) {
        return 'focus';
    }

    if (!touched) {
        return '';
    }

    if (!isFocused && valid) {
        return 'valid';
    }
};

export const updateErrorMessagesWithValues = (fieldsValidation, input, error) =>
    fieldsValidation.reduce((target, key, index) => {
    if (key.name === input.name || input.name.includes('confirmation') && key.name === 'requiresConfirmation') {
        key['value'] = input.value;
        key['errorMessage'] = error;
    }

    target[index] = key;
    return target;
    }, []);

export const updateValues = (fieldsValidation, input, value) =>
    fieldsValidation.reduce((target, key, index) => {
        if (key.name === input.name || input.name.includes('confirmation') && key.name === 'requiresConfirmation') {
            key['value'] = value;
        }

        target[index] = key;
        return target;
    }, []);

export const updateShowingSwissErrors = (updatedFieldsValidation, requiredMessages) =>
    updatedFieldsValidation?.map((item) => {
        let showError = false;
        const errorMessages = requiredMessages.map(el => el.requiredMessage);

        if (item.value && item.errorMessage !== undefined) {
            showError = !errorMessages.includes(item.errorMessage);
        }

        return {
            name: item.name,
            showError
        };
    });
